export default __webpack_public_path__ + "static/media/Helm of Illuminant Conviction.6c7daa33.jpg";